import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";

import Box from "@material-ui/core/Box";

import images from "../../assets/img/images";

import colors from "../../assets/style/colors";

const styles = {
  container: {
    borderRadius: "2px",
    margin: "10px 10px 10px 10px",
    padding: "0px 15px 15px 15px",
  },
  title: {
    background: colors.white,
    transform: "translate(12px, -12px) scale(1.0)",
    display: "inline-block",
    padding: "0px 3px",
  },
};

const DetailsContainer = (props) => {
  const { classes } = props;
  const [open, setOpen] = React.useState(
    !props.foldable ? true : props.defaultOpen || false
  );

  return (
    <Box
      className={classes.container}
      style={{
        border: `1px solid ${colors.black542}`,
        ...props.style,
      }}
    >
      {props.nodeTitle ? (
        <Box component="span" className={classes.title}>
          {props.nodeTitle}
        </Box>
      ) : (
        <Box
          component="span"
          className={classes.title}
          style={{
            color: colors.black54,
            cursor: props.foldable ? "pointer" : "default",
            paddingRight: props.foldable ? "10px" : "3px",
          }}
          onClick={() => (props.foldable ? setOpen(!open) : null)}
        >
          {props.title}
          {props.foldable &&
            (open ? (
              <img
                src={images.bottomArrow}
                alt="bottom_arrow"
                style={{ paddingLeft: "5px", paddingBottom: "1px" }}
              />
            ) : (
              <img
                src={images.bottomArrow}
                alt="left_arrow"
                style={{
                  transform: "rotate(90deg)",
                  paddingBottom: "5px",
                }}
              />
            ))}
        </Box>
      )}
      {(!props.foldable || open) && props.children}
    </Box>
  );
};

DetailsContainer.propTypes = {
  title: PropTypes.string,
  nodeTitle: PropTypes.node,
  foldable: PropTypes.bool,
  defaultOpen: PropTypes.bool,
};

export default withStyles(styles)(DetailsContainer);
